module.exports = __webpack_public_path__ + "img/company-templates.f66fefd5.svg";